import React from 'react';
import styled from 'styled-components';

export const CloseButtton = ({ className, onClose }: any) => {
  return (
    <svg
      onClick={onClose}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        opacity="0.1"
        width="40"
        height="40"
        rx="20"
        transform="matrix(1 0 0 -1 0 40)"
        className="circle"
      />
      <path
        className="x-icon"
        d="M24.2426 16.2426C24.5355 16.5355 24.5355 17.0104 24.2426 17.3033L21.0607 20.4853L24.2426 23.6673C24.5355 23.9602 24.5355 24.435 24.2426 24.7279C23.9497 25.0208 23.4749 25.0208 23.182 24.7279L20 21.5459L16.818 24.7279C16.5251 25.0208 16.0503 25.0208 15.7574 24.7279C15.4645 24.435 15.4645 23.9602 15.7574 23.6673L18.9393 20.4853L15.7574 17.3033C15.4645 17.0104 15.4645 16.5355 15.7574 16.2426C16.0503 15.9497 16.5251 15.9497 16.818 16.2426L20 19.4246L23.182 16.2426C23.4749 15.9497 23.9497 15.9497 24.2426 16.2426Z"
      />
    </svg>
  );
};
export default styled(CloseButtton)`
  z-index: 500;
  .circle {
    fill: ${({ theme }) => theme.colors.black};
  }
  .x-icon {
    fill: ${({ theme }) => theme.colors.black};
  }
`;
